import type { WalletKeyring } from '@polaris/core/signing'
import { atom } from 'jotai'
import type { UseWalletOptionsReturn } from '@/src/hooks/wallet/use-wallet-options'

/**
 * We declare this here as a global keyring, we need to cast it because actually this will never be undefined,
 * thanks to `JotaiProvider` defined inside `app/providers.tsx`
 */
export const walletKeyringAtom = atom<WalletKeyring>(
  undefined as unknown as WalletKeyring,
)

export const walletOptionsAtom = atom<UseWalletOptionsReturn>(
  undefined as unknown as UseWalletOptionsReturn,
)
